export default __webpack_public_path__ + "static/media/editPen.7563747b.svg";